import { Component, OnDestroy } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/services/util.service";
import { ResponseAPI, UserType, User } from "src/models/user.model";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { AuthService } from "src/app/services/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { StatusReserva, StatusReservaFilter } from "src/models/reserva.model";
import { Languages } from "src/models/language.model";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "app-history-brochures",
    templateUrl: "./history-brochures.page.html",
    styleUrls: ["./history-brochures.page.scss"],
    standalone: false
})
export class HistoryBrochuresPage implements OnDestroy {
  sub: Subscription;
  listHistory = [];
  claim: UserType;
  status = StatusReserva;
  user: User;
  userType = UserType;
  Languages = Languages;
  showModalEdit = true;
  showModalFilter = false;
  reservSelected = null;
  selectNumber = 0;
  filterForm: UntypedFormGroup;
  reservaId: any;
  isFiltered = false;
  todosStatus = Object.keys(StatusReservaFilter)
  .map(key => ({ id: StatusReservaFilter[key], name: key }));
  constructor(
    private crud: CrudService,
    private util: UtilService,
    private loadCtrl: LoadingController,
    public alertController: AlertController,
    public route: Router,
    public activatedRoute: ActivatedRoute,
    private platform: Platform,
    private auth: AuthService,
    public fb: UntypedFormBuilder
  ) { }

  async ionViewWillEnter() {
    this.activatedRoute.params.subscribe(async (params) => {
      if (params.id) {
        this.reservaId = params.id;
      }

      this.auth.getClaim().then((data) => (this.claim = data));
      this.user = this.auth.user;
      this.filterForm = this.fb.group({
        nomeCliente: [""],
        dataInicio: [""],
        dataFim: [""]
      });
      await this.loadData(null, false);
    });

  }

  getCardColor(item) {
    if (this.claim !== 0)
      return this.status[item.status];
    if (item.vendedorMasterId === this.user.id)
      return "MASTER";
    return this.status[item.status];
  }

  finished(item) {

    const msg = `${item.nomeCliente}'s reservation was successfully completed`;

    this.crud
      .postData(`restaurante/reserva/finalizar?id=${item.id}`)
      .subscribe(
        (response) => {
          this.util.showToast("Reservation successfully completed!");
          this.crud.postData('sms/send-sms', null, {
            numeroDestinatario: item.vendedor.celular,
            mensagem: msg
          }).subscribe(_ => console.log('sucesso'));
          this.loadData(null, false);
        },
        (error) => {
          this.util.showToast(
            "There was a problem finalizing your reservation"
          );
        }
      );
  }

  async loadData(event: any, filtered: boolean) {
    // await this.loadCtrl.dismiss();
    // await this.showLoading();

    if (!filtered) {
      this.filterForm.reset();
    }
    this.sub = this.crud.postData("informativo/historico", null, this.filterForm.value).subscribe(
      async (response: ResponseAPI) => {
        if (response.success) {
          this.isFiltered = filtered;
          if (this.reservaId) {
            this.listHistory = response.data.filter(e => e.id == this.reservaId);
          } else {
            this.listHistory = response.data;
          }
          

          if (event) {
            setTimeout(() => {
              
              event.target.complete();
            }, 2000);
          }

        }
        // await this.loadCtrl.dismiss();
      },
      async (error) => {
        // await this.loadCtrl.dismiss();
        if (event) {
          setTimeout(() => {
            
            event.target.complete();
          }, 2000);
        }
      }
    );
  }

  newReservation(item) {
    sessionStorage.setItem("oldReservation", JSON.stringify(item));
    this.route
      .navigate(["call", "restaurants-booking"])
      .then(result => { });
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadCtrl.create(loadingProps);
    return await loading.present();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  editReserv(reserv) {
    this.showModalEdit = true;
    this.reservSelected = reserv;
    this.selectNumber = this.reservSelected.quantidadePessoas;
  }

  clearModalEdit() {
    this.reservSelected = null;
    this.showModalEdit = false;
  }

  confirmEdition() {
    if (this.reservSelected) {
      const { id, quantidadePessoas } = this.reservSelected;
      const params = {
        'reserva-id': id,
        'quantidade-pessoas': this.selectNumber
      };

      this.crud.patchData('restaurante/reserva', params).subscribe(response => {
        this.loadData(null, false);
        this.util.showToast('Reservation changed successfully');
        this.clearModalEdit();
      }, error => {
        this.util.showToast('An error occurred while editing');
        this.clearModalEdit();
      });
    }
  }

  showFilter() {
    this.filterForm.reset();
    this.showModalFilter = true;
  }

  filterData(event, filtered: boolean) {
    this.reservaId = "";
    this.loadData(event, filtered);
    this.showModalFilter = false;
  }
}
